import { useState } from "react";
import { Footer } from "../components/_shared/Footer";
import { FooterSocialMediaLine } from "../components/_shared/FooterSocialMediaLine";
import { Header } from "../components/_shared/Header";
import { Navbar } from "../components/_shared/Navbar";
import { ArtcileSideBar } from "../components/dedicatedLearningCenter/content/ArtcileSideBar";
import { GetInTouchBlock } from "../components/home/GetInTouchBlock";
import { ArticleMainContent } from "../components/dedicatedLearningCenter/content/ArticleMainContent";
import { Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLanguageTheme } from "../hooks/useLanguageTheme";
import { useGetArticleByDocumentIdQuery } from "../store/api/articlesApiSlice";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import React from "react";
import { DedicatedLearningCenterHeroImg } from "../components/dedicatedLearningCenter/content/DedicatedLearningCenterHeroImg";
import { RelatedArticlesSection } from "../components/dedicatedLearningCenter/content/RelatedArticlesSection";
import { convertToArticleContent } from "../components/dedicatedLearningCenter/logic";
import { IConvertedArticleContent } from "../components/learningCenter/interfaces";
import { FooterDemo } from "../components/_shared/FooterDemo";

export const DedicatedLearningCenter = () => {
  const { i18n } = useTranslation(["learningCenter"]);
  const langTheme = useLanguageTheme();
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const isRTL = i18n.dir() === "rtl";
  const { documentId } = useParams();

  const [activeItemId, setActiveItemId] = useState<string | null>(null);

  const { data: articleData, error } = useGetArticleByDocumentIdQuery(
    documentId ? { lang: i18n.language, documentId } : skipToken
  );

  const [mainArtcileContent, setMainArtcileContent] = React.useState<
    IConvertedArticleContent[]
  >([]);

  React.useEffect(() => {
    if (articleData) {
      const convertedMainData = convertToArticleContent(
        articleData.data.content
      );
      setMainArtcileContent(convertedMainData);

      if (convertedMainData.length > 0) {
        setActiveItemId(convertedMainData[0].id);
      }
    }

    //If an article does not exist in a language
    if (error) {
      setMainArtcileContent([]);
    }
  }, [articleData, error]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        fontFamily: langTheme.mainFont(),
      }}
    >
      <>
        <div className="portfolio-header-sticky-wrapper">
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 1)",
            }}
          >
            <Header>
              <Navbar />
            </Header>
          </div>
        </div>
        <DedicatedLearningCenterHeroImg article={articleData?.data} />
        <div
          className="main-article-wrapper xl-width"
          style={{
            padding: "0 20px",
            boxSizing: "border-box",
            direction: isRTL ? "ltr" : "rtl",
            justifyContent: downMd ? "flex-end" : "space-between",
          }}
        >
          {!downMd && (
            <ArtcileSideBar
              items={mainArtcileContent}
              activeItemId={activeItemId}
            />
          )}
          <ArticleMainContent
            items={mainArtcileContent}
            setActiveItemId={setActiveItemId}
          />
        </div>
        <RelatedArticlesSection />
        <GetInTouchBlock />
        {/* <Footer /> */}
        <FooterDemo />
        <FooterSocialMediaLine />
      </>
    </div>
  );
};
